import React from "react";
import { baseUrl } from "../../utils/base_url";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
} from "../../utils/mediaBreakpoints";

const HomeShadowCard = ({
  isMobile,
  heading,
  icon,
  shadow,
  rightcorner,
  background,
}) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  return (
    <>
      <div
        className={`position-relative text-white`}
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: background,
          borderRadius: "1rem",
          boxShadow: shadow,
          overflow: "hidden",
        }}
      >
        <div
          className="position-absolute bottom-0 end-0 "
          style={{
            background: rightcorner,
            width: "20%",
            height: "35%",
            clipPath: "polygon(0 100%, 100% 0, 100% 100%)",
            zIndex: 0,
          }}
        />
        <div
          className="px-4 d-flex gap-3 align-items-center position-relative "
          style={{ width: "100%", height: "100%", zIndex: 2 }}
        >
          <img
            src={`${baseUrl}${icon}`}
            style={{
              width: _576
                ? "60px"
                : _768
                ? "64px"
                : _992
                ? "64px"
                : _1200
                ? "50px"
                : _1400
                ? "44px"
                : _1500
                ? "54px"
                : _1600
                ? "59px"
                : _1700
                ? "65px"
                : _1800
                ? "67px"
                : "69.89px",
              height: _576
                ? "61px"
                : _768
                ? "65px"
                : _992
                ? "65px"
                : _1200
                ? "61px"
                : _1400
                ? "45px"
                : _1500
                ? "55px"
                : _1600
                ? "60px"
                : _1700
                ? "68px"
                : _1800
                ? "68px"
                : "71.15px",
            }}
          />
          <p
            className="fw800 my-0 lh-1"
            style={{
              fontSize: _576
                ? "24px"
                : _768
                ? "30px"
                : _992
                ? "30px"
                : _1200
                ? "27px"
                : _1400
                ? "14px"
                : _1500
                ? "18px"
                : _1600
                ? "19px"
                : _1700
                ? "20px"
                : _1800
                ? "23px"
                : "26px",
            }}
            dangerouslySetInnerHTML={{
              __html:heading?.replace(/ n /gi, "<br/>")
            }}
          >
            {/* {heading} */}
          </p>
        </div>
      </div>
    </>
  );
};

export default HomeShadowCard;
